import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  APPLICATION,
  APPLICATION_ALL,
  APPLICATION_ANALYTICS,
  APPLICATION_CATEGORY,
  APPLICATION_CATEGORY_ALL,
  APPLICATION_CATEGORY_LIST,
  APPLICATION_CHANGE_COURSE,
  APPLICATION_FIELDS,
  APPLICATION_FIELD_BATCH,
  APPLICATION_GENERATE,
  APPLICATION_LIST,
  APPLICATION_REQUEST_ALL,
  APPLICATION_REQUEST_EDIT,
  APPLICATION_REQUEST_UPDATE,
  APPLICATION_STATUS,
  APPLICATION_TYPES,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const admissionSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const applicationSelector = createSelector(admissionSelectors, prop(APPLICATION))

export const applicationListSelector = createSelector(admissionSelectors, prop(APPLICATION_LIST))

export const applicationAnalyticsSelector = createSelector(admissionSelectors, prop(APPLICATION_ANALYTICS))

export const applicationFieldsSelector = createSelector(admissionSelectors, prop(APPLICATION_FIELDS))

export const applicationGenerateSelector = createSelector(admissionSelectors, prop(APPLICATION_GENERATE))

export const applicationChangeCourseSelector = createSelector(admissionSelectors, prop(APPLICATION_CHANGE_COURSE))

export const applicationTypesSelector = createSelector(admissionSelectors, prop(APPLICATION_TYPES))

export const applicationStatusSelector = createSelector(admissionSelectors, prop(APPLICATION_STATUS))

export const applicationAllSelector = createSelector(admissionSelectors, prop(APPLICATION_ALL))

export const applicationFieldBatchSelector = createSelector(admissionSelectors, prop(APPLICATION_FIELD_BATCH))

// category
export const applicationCategorySelector = createSelector(admissionSelectors, prop(APPLICATION_CATEGORY))

export const applicationCategoryListSelector = createSelector(admissionSelectors, prop(APPLICATION_CATEGORY_LIST))

export const applicationCategoryAllSelector = createSelector(admissionSelectors, prop(APPLICATION_CATEGORY_ALL))

// request
export const applicationRequestAllSelector = createSelector(admissionSelectors, prop(APPLICATION_REQUEST_ALL))

export const applicationRequestEditSelector = createSelector(admissionSelectors, prop(APPLICATION_REQUEST_EDIT))

export const applicationRequestUpdateSelector = createSelector(admissionSelectors, prop(APPLICATION_REQUEST_UPDATE))
